/**
 * Copyright (c) 2020
 *
 * @summary calls to dataReport/websitePages API
 * @author Julien <julien.donnadieu@yooda.com>
 *
 * Created at     : 2020-11-17 10:21:56
 * Last modified  : 2020-11-17 15:31:17
 */

import axios from '@/api/axios.js'

export default {

    /**
     * @param projectId int
     * @param filters
     * @returns Promise
     */
    readBestPages (projectId, filters=null) {
        return axios.get(`/report/data/projects/${projectId}/dashboard/website-page/best-pages`, filters)
    },

    /**
     * @param projectId int
     * @param filters
     * @returns Promise
     */
    readBestPositionedPages (projectId, filters=null) {
        return axios.get(`/report/data/projects/${projectId}/website-page/best-positioned-pages`,filters)
    },

    /**
     * @param projectId int
     * @returns Promise
     */
    readPositionedCountEvolution (projectId, filters=null) {
        return axios.get(`/report/data/projects/${projectId}/website-page/positioned-pages-count-evolution`,filters)
    },

    /**
     * @param projectId int
     * @returns Promise
     */
    readPositionedTypeCount (projectId) {
        return axios.get(`/report/data/projects/${projectId}/website-page/positioned-pages-type`)
    },

    /**
     * @param projectId integer
     * @param externalPageId integer
     * @param filters
     * @returns Promise
     */
    readBestPositionedPagePositions (projectId,externalPageId, filters=null) {
        return axios.get(`/report/data/projects/${projectId}/website-page/best-positioned-page-positions/pages/${externalPageId}`,filters)
    },

};
